import { Route } from 'react-router-dom'

import Parking404 from '../../components/Parking/404'
import PaymentSuccessRedirectToPage from '../../components/Parking/components/Payment/PaymentSuccessRedirectToPage'
import ParkingGuestInfo from '../../components/Parking/ParkingGuestInfo'
import ParkingPaymentPage from '../../components/Parking/ParkingPaymentPage'
import ParkingServicesInfo from '../../components/Parking/ParkingServicesInfo'
import ParkingSummary from '../../components/Parking/ParkingSummary'

export const valetParkingRoutesConfig = () => (
  <Route path="parking">
    {/* ticketNumber is a bearer credential (see getParkingTicket in api.js - no auth token is
    sent, the ticket number alone authorizes the lookup) and gets scrubbed from Sentry/PostHog -
    see SENSITIVE_PATH_PARAMS in scrub-event-properties.ts. Changing this path must stay in sync
    with that entry; scrub-event-properties.route-sync.test.ts fails CI if not. */}
    <Route path=":ticketNumber" element={<ParkingGuestInfo />} />
    <Route path=":ticketNumber/services-info" element={<ParkingServicesInfo />} />
    <Route path=":ticketNumber/payment" element={<ParkingPaymentPage />} />
    <Route path=":ticketNumber/summary" element={<ParkingSummary />} />
    <Route path=":ticketNumber/payment-success" element={<PaymentSuccessRedirectToPage />} />
    <Route path="error/404" element={<Parking404 />} />
  </Route>
)
